<script setup lang="ts">
import PaginationPrevComponent from "./PaginationPrev.vue";
</script>

<template>
  <PaginationPrevComponent />
</template>
